import { useRole } from '../context/roleContext';
import useAuth from './useAuth';
import { useEffect } from 'react';

/**
 * Custom hook for role-based access control
 * This hook automatically syncs the user's role from auth context
 * and provides all role-based functionality
 */
export const useRoleAccess = () => {
  const { user } = useAuth();
  const roleContext = useRole();
  const { setUserRole, clearRoleData } = roleContext;

  // Sync role when user changes
  /**
   * Effect: synchronize role context from the authenticated user.
   * - When `user.role` is present, set it in `RoleContext`.
   * - Otherwise clear role data to fall back to unauthenticated state.
   */
  useEffect(() => {
    if (user && user.role) {
      setUserRole(user.role);
    } else {
      clearRoleData();
    }
  }, [user, setUserRole, clearRoleData]);

  return roleContext;
};